var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_c('kevideo',{attrs:{"order":false,"list":_vm.list}}),(_vm.list.length == 0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("没有更多的数据")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }